"use strict";

define('model/organization.approver',['underscore', './base', 'datakit/util/url'], function (_, BaseModel, _url) {
  var OrganizationApprover = BaseModel.extend({
    urlRoot: '/rs/api/org/:organizationId/approver',
    url: function url() {
      return _url.template(this.urlRoot, this);
    },
    virtual: {
      'personId': BaseModel.createKeyPathVirtual('person.id')
    },
    childModels: {
      person: 'Person'
    },
    isNew: function isNew() {
      if (this._isNotNew) {
        this._isNotNew = false;
        return false;
      }
      return BaseModel.prototype.isNew.apply(this, arguments);
    },
    destroy: function destroy(options) {
      var self = this;
      options = _.extend({}, options, {
        success: function success() {
          self._isNotNew = true;
        }
      });
      this._isNotNew = true;
      return BaseModel.prototype.destroy.call(this, options);
    },
    sync: function sync(method, model, options) {
      options = options || {};
      if (method != 'read') {
        options.attrs = {
          persons: [model.get('personId')]
        };
      }
      if (method == 'delete') {
        options.contentType = 'application/json';
        options.data = JSON.stringify(options.attrs);
      }
      return BaseModel.prototype.sync.call(this, method, model, options);
    }
  }, {
    all: function all(organizationId) {
      return this.createCollection('/rs/api/org/:organizationId/approver').params({
        organizationId: organizationId
      });
    },
    create: function create(person, org) {
      return new this({
        person: person,
        organizationId: org.id
      });
    }
  });
  return OrganizationApprover;
});

